import B2BHeader from './B2BHeader';

export default B2BHeader;
